import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
//import { getAllMstBranch } from "../redux/handlers/master/getAllMstBranch.handler";
//import { useGlobalSelectedBranchContext } from "contexts/GlobalSelectedBranchContext";
import { logout } from "../redux/handlers/auth/logout.handler";
import { useNavigate } from "react-router-dom";
import { VER } from "constants/server/api";
import { SERVER_NAME } from "constants/server/config";
import { getInfoAdminSystem } from "utils/HelperFunction";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
export function Navcustom() {
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var adminInfo = getInfoAdminSystem(localStorage.getItem("accessToken"));
    var userDisplayName = adminInfo.userFullName || [
        adminInfo.userFname,
        adminInfo.userLname
    ].filter(Boolean).join(" ") || adminInfo.username || "-";
    // const { selectedBranchId, setSelectedBranchId } =
    //   useGlobalSelectedBranchContext();
    var _useState = _sliced_to_array(useState(false), 2), isOpenAvatarMenu = _useState[0], setIsOpenAvatarMenu = _useState[1];
    var toggleAvatarDropdown = function() {
        return setIsOpenAvatarMenu(!isOpenAvatarMenu);
    };
    // const loadAllMsts = () => {
    //   dispatch(getAllMstBranch());
    // };
    // const getAllMstBranchReducer = useAppSelector(
    //   (state) => state.getAllMstBranchReducer
    // );
    var _useState1 = _sliced_to_array(useState([]), 2), optionsMstBranch = _useState1[0], setOptionsMstBranch = _useState1[1];
    // useEffect(() => {
    //   loadAllMsts();
    // }, []);
    // useEffect(() => {
    //   setIsLoading(getAllMstBranchReducer.isFetching);
    //   if (getAllMstBranchReducer.data) {
    //     setOptionsMstBranch(
    //       getAllMstBranchReducer.data.data.map((item) => ({
    //         label: item.name,
    //         value: item.id,
    //       }))
    //     );
    //   }
    // }, [getAllMstBranchReducer]);
    function handleSidebar(e) {
        var sidebar = document.getElementsByClassName("app");
        for(var i = 0; i < sidebar.length; i++){
            sidebar[i].classList.toggle("sidenav-toggled");
        }
    }
    var _process_env_REACT_APP_ENV, _process_env_REACT_APP_ENV1;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            !isMobile && /*#__PURE__*/ _jsx("nav", {
                className: "navbar fixed-top navbar-st-1",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "container-fluid",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx("a", {
                                    className: "logo-icon mobile-logo px-0 icon-light active",
                                    href: "",
                                    children: /*#__PURE__*/ _jsx("img", {
                                        src: process.env.REACT_APP_LOGO_URL,
                                        className: "logo-icon mx-auto",
                                        alt: "logo"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "fs-16 text-white ml-5",
                                    children: [
                                        "server: ",
                                        (_process_env_REACT_APP_ENV = process.env.REACT_APP_ENV) !== null && _process_env_REACT_APP_ENV !== void 0 ? _process_env_REACT_APP_ENV : "-",
                                        " | ",
                                        SERVER_NAME,
                                        " v.",
                                        VER
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "d-flex align-items-center",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "dropdown",
                                children: [
                                    /*#__PURE__*/ _jsx("a", {
                                        className: "btn  dropdown-toggle-1 drop-right ",
                                        role: "button",
                                        "data-bs-toggle": "dropdown",
                                        "aria-expanded": "false",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "d-flex align-items-center",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "text-white me-2 fs-14",
                                                    children: userDisplayName
                                                }),
                                                /*#__PURE__*/ _jsx("img", {
                                                    src: "/images/Avatar.png",
                                                    className: "Avatar",
                                                    alt: "ผู้ใช้งาน"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("ul", {
                                        className: "dropdown-menu dropdown-menu-end",
                                        children: [
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("button", {
                                                    className: "dropdown-item text-color-6",
                                                    onClick: function() {
                                                        return navigate("/profile");
                                                    },
                                                    children: "โปรไฟล์"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("button", {
                                                    className: "dropdown-item text-color-6",
                                                    onClick: function() {
                                                        return logout(navigate, "/login");
                                                    },
                                                    children: "ออกจากระบบ"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            isMobile && /*#__PURE__*/ _jsxs("nav", {
                className: "navbar fixed-top navbar-st-1",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex align-items-center",
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                className: "logo-icon mobile-logo px-0 icon-light active",
                                href: "",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: process.env.REACT_APP_LOGO_URL,
                                    className: "logo-icon mx-auto",
                                    alt: "logo"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "fs-16 text-white ml-5",
                                children: [
                                    "server: ",
                                    (_process_env_REACT_APP_ENV1 = process.env.REACT_APP_ENV) !== null && _process_env_REACT_APP_ENV1 !== void 0 ? _process_env_REACT_APP_ENV1 : "-",
                                    /*#__PURE__*/ _jsx("br", {}),
                                    SERVER_NAME,
                                    " v.",
                                    VER
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex align-items-center",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "dropdown",
                            children: [
                                /*#__PURE__*/ _jsx("a", {
                                    className: "btn dropdown-toggle-1 drop-right ",
                                    role: "button",
                                    "data-bs-toggle": "dropdown",
                                    "aria-expanded": "false",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "d-flex align-items-center",
                                        children: /*#__PURE__*/ _jsx("img", {
                                            src: "/images/Avatar.png",
                                            className: "Avatar",
                                            alt: "ผู้ใช้งาน"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("ul", {
                                    className: "dropdown-menu dropdown-menu-end",
                                    children: [
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "dropdown-item-text fw-semibold text-color-6 text-wrap",
                                                style: {
                                                    minWidth: "200px",
                                                    wordBreak: "break-word"
                                                },
                                                title: userDisplayName,
                                                children: userDisplayName
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("hr", {
                                                className: "dropdown-divider"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("button", {
                                                className: "dropdown-item text-color-6",
                                                onClick: function() {
                                                    return navigate("/profile");
                                                },
                                                children: "โปรไฟล์"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("button", {
                                                className: "dropdown-item text-color-6",
                                                onClick: function() {
                                                    return logout(navigate, "/login");
                                                },
                                                children: "ออกจากระบบ"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
